import styles from './ColorBar.module.css';

// The two colour-accent looks the app uses. They vary together on width, height
// and opacity, so they are named variants rather than independent props:
// 'line' is the muted hairline that spans a multi-line row, 'block' is the solid
// short marker that sits beside a single-line heading.
export type ColorBarVariant = 'line' | 'block';

interface ColorBarProps {
  // Any CSS colour value: a token reference like var(--color-graphics-graph-first),
  // or a stored hex for entities that carry their own colour.
  color: string;
  variant?: ColorBarVariant;
}

// A thin vertical bar carrying an entity's colour identity next to its label.
// Decorative by design: the colour only ever repeats what the adjacent text
// already says, so it stays out of the accessibility tree.
export const ColorBar = ({ color, variant = 'line' }: ColorBarProps) => (
  <span
    className={`${styles.bar} ${styles[variant]}`}
    style={{ backgroundColor: color }}
    aria-hidden="true"
  />
);
